/**
 * Display helpers for tree-level Legacy Book preview.
 */
import { getProfileType, isCompanionProfile, PROFILE_TYPE, PET_SPECIES } from './companionProfiles';

export const TREE_BOOK_COPY = {
  promise: 'MyLegacyBridge helps families preserve memories, stories and loved ones before they are lost forever.',
  coverSubtitle: 'Stories, memories and photographs preserved for future generations.',
  coverTagline: 'Before memories fade — preserved for those who come after.',
  openingLead:
    'This Legacy Book gathers the voices, photographs and stories your family has chosen to keep — a keepsake you can return to, share, and add to over time.',
  openingGentle: 'This Legacy Book can start simple. Add more memories whenever you are ready.',
  closingLead:
    'Every story preserved here is a gift to those who come next. Created with love, for your family to hold onto.',
  emptyBook: 'This Legacy Book can start simple.',
  emptyPeople: 'Every story helps this book grow — begin with one loved one.',
  emptyMemories: 'Memories you save will gather here as readable stories.',
  emptyPhotos: 'Photos can be added later — each image deepens the story.',
  emptyTimeline: 'Key dates and moments will appear as you add them.',
  emptyBio: 'A few words about their life can open this chapter when you are ready.',
};

export function getPersonRoleLabel(person) {
  const type = getProfileType(person);
  if (type === PROFILE_TYPE.PET) {
    const species = person?.pet_species || person?.species;
    const match = PET_SPECIES.find((s) => s.value === species);
    if (match) return match.label;
    if (species) return String(species).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
    return 'Family pet';
  }
  if (type === PROFILE_TYPE.COMPANION) {
    return 'Companion';
  }
  return null;
}

export function partitionPeopleForBook(people = []) {
  const lovedOnes = [];
  const companions = [];
  for (const person of people) {
    if (isCompanionProfile(person)) companions.push(person);
    else lovedOnes.push(person);
  }
  return { lovedOnes, companions };
}

export function peopleOverviewTitle(lovedOnes, companions) {
  if (lovedOnes.length && companions.length) return 'Loved ones & companions';
  if (companions.length && !lovedOnes.length) return 'Companions in this archive';
  return 'The people in this book';
}

export function formatPersonCounts(counts) {
  if (!counts) return null;
  const parts = [];
  if (counts.stories) parts.push(`${counts.stories} ${counts.stories === 1 ? 'memory' : 'memories'}`);
  if (counts.documents) parts.push(`${counts.documents} ${counts.documents === 1 ? 'photo' : 'photos'}`);
  return parts.length ? parts.join(' · ') : null;
}
